import React, { useState } from 'react';
import styled from 'styled-components';

const Section4Wrapper = styled.section`
  width: 100%;
  background-color: #1F1F1F;
  padding: 5% 20%;
  box-sizing: border-box;
  margin:0 auto;

  @media (max-width: 500px) {
    padding: 5% 0% 10% 0%;
    width:100vw;

  }
`;

const UpperSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;


  @media (max-width: 500px) {
    flex-direction: column;
    align-items: flex-start;
    padding:0% 0% 0% 0%;
    text-align: center;


  }
`;

const Title = styled.h2`
  font-style: normal;
  font-weight: 700;
  font-size: 52px;
  line-height: 61px;
  letter-spacing: 0.05em;
  color: #FFFFFF;
  padding:0% 10% 0% 0%;
  width:40%;



  span {
    color: #FFF56A;
  }

  @media (max-width: 500px) {
    font-size: 32px;
    line-height: 46px;
    width:80%;
    padding:0% 0% 0% 0%;
    margin:0 auto;
   

  }
`;

const Description = styled.p`
  color: #FFFFFF;
  font-weight: 500;
  font-size: 18px;
  line-height: 32px;
  flex: 1;
  

  @media (max-width: 500px) {
    margin-left: 0;
    margin-top: 0%;
    width:90%;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    padding:5% 0% 0% 0%;
    margin:0 auto;
  }
`;

const LowerSection = styled.div`
  display: flex;
  flex-direction: column; /* 將卡片排列改為垂直方向 */
  gap: 20px; /* 設定垂直間距 */

  @media (max-width: 500px) {
    
    width:90%;
    padding:0% 5% 0% 5%;
  }
`;

const ArrowIcon = styled.span`
  font-size: 16px;
  line-height: 1;
  display: inline-block;
  vertical-align: middle;
  transition: transform 0.3s ease;
  cursor: pointer;

  &:before {
    content: '^';
    color: #FFFFFF; 
    font-size: 32px;
  }

  ${(props) => (props.expanded ? 'transform: rotate(0deg);' : 'transform: rotate(180deg);')}

  @media (max-width: 500px) {
    margin-top:0;
    

    
  }

`;



const Card = styled.div`
  background-color: #000000;
  border-radius: 30px;
  overflow: hidden;
  
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding:2% 3% 2% 3%;

  @media (max-width: 500px) {
    
    padding:4% 5% 4% 5%;
    border-radius: 16px;
    max-width:100%;

    
  }


`;

const CardContent = styled.div`
  
  flex: 1;
`;

const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;

  @media (max-width: 500px) {
    
    

    
  }
`;

const CustomTitle = styled.h3`
  font-style: normal;
  font-weight: 500;
  font-size: 28px;
  line-height: 41px;
  color: #FFF56A;
  margin: 0;
  cursor: pointer;

  @media (max-width: 500px) {
    
    font-size: 18px;
    line-height: 26px;
  }
`;

const CustomDescription = styled.div`
  color: #AFAFAF;
  margin: 10px 0 10px 0;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  width:90%;
  cursor: pointer;




  @media (max-width: 500px) {
    
    margin:0;
    font-size: 14px;
    line-height: 22px;

  }
`;

const ExpandDIV = styled.div`
  display: flex;
  flex: 1;
  white-space: pre-line;
  width: 80%;
  margin:0 auto;
  padding:3% 0% 3% 0%;


  div {
    max-width:50%;
  }

  @media (max-width: 500px) {
    flex-direction: column;
    align-items: center;
    margin:0;
    width: 80vw;


    div {
      max-width: 80vw;
    }
  }


`;

const ImageContainer = styled.div`
  width: 40%; 
  margin-right: 5%;
  cursor: pointer;


  img {
     width: 100%;
     height: auto;
     border-radius: 30px;
   }

   a{

   }

  @media (max-width: 500px) {
    width: auto;
    height: 100%;
    margin-right: 0%;

    img {
      width: 100%;
      height: auto;
      border-radius: 30px;
    }
  }

`;

const Expandtitle = styled.h3`
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 43px;
  color: #FFFFFF;
  margin: 0;

  @media (max-width: 500px) {
    
    font-size: 18px;
    line-height: 26px;
    padding:5% 0% 0% 0%;
  }
`;

const Expandsubtitle = styled.p`
  color: #FFFFFF;
  margin: 10px 0 10px 0;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 32px;

  @media (max-width: 500px) {
    
    
    word-wrap: break-word;
  }
`;

const Expanddescription = styled.p`
  color: #AFAFAF;
  margin:0% 0% 5% 0%;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  width:100%;



  @media (max-width: 500px) {
    
    margin:0;
    font-size: 14px;
    line-height: 22px;
    
    word-wrap: break-word;



  }
`;

const Button = styled.a`
  text-decoration: none;
  background-color:transparent;
  color:#FFFFFF;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 26px;
  letter-spacing: 0.05em;
  

  padding: 12px 40px;
  box-sizing: border-box;
  border: 1px solid rgba(255, 255, 255, 0.6);
  border-radius: 100px;

  
  @media (max-width: 500px) {
    font-size: 14px;
    line-height: 24px;
    margin-top:0px;
    padding: 6px 20px;
    margin: 0 auto;


  }

  &:hover {
    background-color:#FFFFFF;
    color:#1f1f1f;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  flex-direction: row;
  margin-top:5%;
  gap: 5%;

  @media (max-width: 500px) {
    flex-direction: row;
    padding:0% 15% 0% 15%;
   
  }

`;

const ExpandableCard = ({ title, subtitle, imageUrl, expanded, onToggle,expandtitle,expandsubtitle1,expanddescription1,expandsubtitle2,expanddescription2,expandsubtitle3,expanddescription3,url }) => (
  <Card >
    <CardContent >
      <TitleContainer onClick={onToggle} >
        <CustomTitle>{title}</CustomTitle>
        <ArrowIcon  expanded={expanded ? 1 : 0} />
      </TitleContainer>
      <CustomDescription onClick={onToggle}>{subtitle}</CustomDescription>
      {expanded && 
      
        
          <ExpandDIV>
            <ImageContainer>
              <a href={url} target="_blank" rel="noopener noreferrer">
              <img src={imageUrl} alt={title} style={{ width: '100%', height: 'auto' }} />
              </a>
            </ImageContainer>
            <div>
              <Expandtitle>{expandtitle}</Expandtitle>
              <Expandsubtitle>{expandsubtitle1}</Expandsubtitle>
              <Expanddescription>{expanddescription1}</Expanddescription>
              <Expandsubtitle>{expandsubtitle2}</Expandsubtitle>
              <Expanddescription>{expanddescription2}</Expanddescription>
              <Expandsubtitle>{expandsubtitle3}</Expandsubtitle>
              <Expanddescription>{expanddescription3}</Expanddescription>
              
            </div>

          </ExpandDIV>


        
      }
    </CardContent>
  </Card>
);



const RetroPGFSec4 = () => {
  const [expandedCards, setExpandedCards] = useState([0]);

  const toggleExpansion = (index) => {
    setExpandedCards((prevExpandedCards) => {
      const isExpanded = prevExpandedCards.includes(index);
      if (isExpanded) {
        return prevExpandedCards.filter((item) => item !== index);
      } else {
        return [...prevExpandedCards, index];
      }
    });
  };

  return (
    <Section4Wrapper>
      <UpperSection>
        <Title>
          FOSS and open data playground<span>.</span>
        </Title>
        <Description>
          本次徵案實驗，以私人方式募集捐款資金新台幣 40 萬元。共徵得 7 組數位公共財建設專案，於 2023 年12 月 20 日完成鏈上回溯資助。<br/><br/>利害相關聲明：此次獎助資金為私人募集，非政府資金。<br/>
          <ButtonGroup>
            <Button href="https://g0v.hackmd.io/HX8a1HHURmCaCKQlUu_Dhg?view" target="_blank" style={{ textDecoration: 'none' }}>成果發表</Button>
            <Button href="https://drive.google.com/file/d/1bRGBkevKEwcrUbLELyDY58i2eusXul5Y/view?usp=sharing" target="_blank" style={{ textDecoration: 'none' }}>閱讀更多</Button>
          </ButtonGroup>
        </Description>

      </UpperSection>
      <LowerSection>  
          <ExpandableCard
            key={0}
            title={`立法院大小聲`}
            subtitle="提供廣大⺠眾更易用的立法院資訊平台數位版開放國會"
            imageUrl="/images/RetroPGFSec4_1.png"
            url=""
            expanded={expandedCards.includes(0)}
            onToggle={() => toggleExpansion(0)}
            expandtitle="《立法院大小聲》早期貢獻"
            expandsubtitle1="Description"
            expanddescription1="開放國會 | 你知道自己選出的立委，平常在做什麼嗎？"
            expandsubtitle2="Contributors"
            expanddescription2={"@denkeni\n@wwwanyuchang"}
            expandsubtitle3="Owners / Share"
            expanddescription3={"0x21c22cd781e43acb20b4b1fa0e53cbef01c8d5b2/ 90.0%\n0x113db1f831b75094eff7293ba5d12eaf5af60ae6 / 10.0%"}
          />
          <ExpandableCard
            key={1}
            title={`Thaubing ESG 開放企業永續資料庫`}
            subtitle="永續報告書應為企業對外溝通之重要管道， Thaubing ESG 希望企業如實揭露資訊，避免報告書成為企業漂綠工具。"
            imageUrl="/images/RetroPGFSec4_2.png"
            url=""
            expanded={expandedCards.includes(1)}
            onToggle={() => toggleExpansion(1)}
            expandtitle="開放企業永續資料庫 - 工人智慧判讀器 MVP"
            expandsubtitle1="Description"
            expanddescription1={"面對氣候風險，為了促進台灣企業的淨零轉型，我們想要透過開發企業永續報告書的自動、半自動判讀工具，降低判讀成本，充實開放台灣企業永續資料庫的內容，讓政府、各級企業與公民團體，都能夠透過數據，制定合宜的制度、策略、倡議目標。\n\n\n在 MVP 階段，我們做了：\n\n\n1.使用者訪談，確認既有使用流程、接觸點、以及問題\n2.製作 POC 與 MVP ，並進行多輪驗證"}
            expandsubtitle2="Contributors"
            expanddescription2={"0x73100f2e9fc6aef4a021ccf3654d319eaac9abea\n0x913522b0722e60ddfaf4bc0487af78d47dd8d180\n0x153b8362fd58294a74d9a0c7790f75fa7fee11f4\n0xbb473a3a5bbf37ff738298b5eafb55132a85572a"}
            expandsubtitle3="Owners / Share"
            expanddescription3={"Unclaimed / 100%"}
          />
       
          <ExpandableCard
            key={2}
            title={`Shoutout`}
            subtitle="在社群平台打造機器人，記錄下社群的互動，讓每個人可以自然地成為彼此的吟遊詩人，所有的記錄累積起來就成為史詩。"
            imageUrl="/images/RetroPGFSec4_3.png"
            url=""
            expanded={expandedCards.includes(2)}
            onToggle={() => toggleExpansion(2)}
            expandtitle="Shoutout X FABDAO  | 來一 shot"
            expandsubtitle1="Description"
            expanddescription1={"Shoutout (discord version) 是 da0 與 FAB DAO 合作的感謝大聲公，也是一份去中心化身份的履歷。應用於不同社群，謄錄對社群貢獻者的感謝，與社群互動的重要時刻。緣起：da0 與 FAB DAO 兩個社群的許多成員經常交流互動，於今年(2023)9月搭起了合作橋梁，嘗試共同打造Discord版紀錄機器人。\nda0/Shoutout: 昶惟, Noah, Lucky, Peixing, Weijen, Tofus, Matt\nFAB DAO 超證小組: Chubbytank, Stanley, Kay, Frank, Yian, Danny\n彈性參與者: Denkeni, Zoey, Gim GM\n\n“Shoutout (Discord version)” is a thank-you loudspeaker made by da0 and FAB DAO in partnership as well as a decentralized résumé of identity. It is used in a variety of communities to document expressions of gratitude to community contributors and noteworthy moments of community engagement.\nMembers of da0 and FAB DAO communicate often in various online and offline activities. Since September 2023, da0 and FAB DAO have been working together to develop the Shoutout bot in Discord version to amplify the impact.\n--- Issuer: chubbytank.eth"}
            expandsubtitle2="Contributors"
            expanddescription2={"mattlee46.eth\n0xabcb252df3644f118b2bb286241a7234b63b057c\n0x15c7281842a45465b4cbb8f89111d99e36e5bab8\n0xfe70e739c44615a500ec4bfc95563fe9c40bbc5f\n0xafcca66ca8737fe647b7e94cb1a0891a72ab3ae5\n0x7cd7d564c2bfa56a745e89204c457e1205595348\n0x0624aa196299088f7229defcee316df5198c1255\nchubbytank.eth\nstanleyleo.eth\n0x1e6ed99ecf3c5fbaae4fae8a183d925393cc38fd\n0x5fd15ef419c907717362fa82b8c364a3959f2bac\n0x5d3f7c09c0132c2c5a78ec2e654b9068f5550954\n0xcfb9fc585ed11bb8a6e79547920d825b6666bf55\ndenkeni.eth"}
            expandsubtitle3="Owners / Share"
            expanddescription3={"0x740a92667afbe58bd1cf086625951f9a7197d2ee / 7.46%\n0xabcb252df3644f118b2bb286241a7234b63b057c / 7.46%\n0x0624aa196299088f7229defcee316df5198c1255 / 7.46%\n0x5fd15ef419c907717362fa82b8c364a3959f2bac / 7.46%\n0xafcca66ca8737fe647b7e94cb1a0891a72ab3ae5 / 7.46%\n0xfbfac05bd50e868fbaa842363883b23d9045a24f / 7.46%\n0xdee9d3a767e08afcffc909e55d853a0069c2f46f / 1.49%\nUnclaimed / 53.7%"}
          />
          
          <ExpandableCard
            key={3}
            title={`Cofacts`}
            subtitle="Cofacts 發起於 2016 年，以開發開放原始碼的科技工具解決假訊息問題為初心，透過開放資料與群眾協作，為維護言論自由的形式對抗錯誤資訊。"
            imageUrl="/images/RetroPGFSec4_4.jpeg"
            url=""
            expanded={expandedCards.includes(3)}
            onToggle={() => toggleExpansion(3)}
            expandtitle="Cofacts 真的假的"
            expandsubtitle1="Description"
            expanddescription1={"Cofacts 真的假的 訊息回報機器人與查證協作社群\n\n我們是誰\n我是 Johnson，是工程師，也是 Cofacts 真的假的 訊息回報機器人與查證協作社群 的創辦人。核心成員還有比鄰與斌綸。我們認為維護資訊環境不該只是少數人的責任；越多人具備媒體識讀素養並實踐於查核協作，使民眾把對假訊息的焦慮轉化為貢獻的動力，整個民主社會就會越有對抗假訊息的韌性。\n\nCofacts 是什麼\n「Cofacts 真的假的」是一套連結網路訊息與事實查核的協作型系統。\n其中：\n網路訊息：透過 [LINE chatbot](https://lin.ee/3KCZgIq) （ID：`@cofacts` ）搜集使用者所回報的 LINE 上的轉傳訊息。\n事實查核：編輯們在網路上找到的現有查證文章或是撰寫的回應。\n協作型系統：任何人都可以轉傳訊息進來。並且，任何人都可以當查核協作者，一起在網站(https://cofacts.tw/)上面一同協作。產出的內容以 CC BY-SA 釋出(https://github.com/cofacts/opendata)，系統本身亦為開放原始碼專案(https://beta.hackfoldr.org/1yXwRJwFNFHNJibKENnLCAV5xB8jnUvEwY_oUq-KcETU/https%253A%252F%252Fhackmd.io%252Fs%252Fr1nfwTrgM)。\n使用者在 LINE 上對可疑訊息長按並分享給 Cofacts 的 LINE chatbot，就能得到查核協作者們所撰寫的回應。"}
            expandsubtitle2="Contributors"
            expanddescription2={""}
            expandsubtitle3="Owners / Share"
            expanddescription3={""}
          />

          <ExpandableCard
            key={4}
            title={`Disfactory`}
            subtitle="此專案旨在創建安全、便利、匿名的農地違章回報平台，追蹤政府查處違章工廠進度。一同守護台灣農地，把乾淨的糧食生產環境留給下一代！"
            imageUrl="/images/RetroPGFSec4_5.jpeg"
            url=""
            expanded={expandedCards.includes(4)}
            onToggle={() => toggleExpansion(4)}
            expandtitle="Disfactory"
            expandsubtitle1="Description"
            expanddescription1={"disfactory專案由長期關注違章工廠的地球公民基金會，以及開源社群的參與者組成。\n立志成為吹哨者的後盾，創建安全、便利、匿名的民間版農地違章回報平台，協助民眾回報哪裡有違章工廠、並追蹤政府查處違章工廠的結果。結合全台灣公民的力量一同守護台灣農地，把乾淨的糧食生產環境留給下一代。"}
            expandsubtitle2="Contributors"
            expanddescription2={"0xcb20f706e114adea1e0cbd58c91bda2efdd7b656"}
            expandsubtitle3="Owners / Share"
            expanddescription3={"0xcb20f706e114adea1e0cbd58c91bda2efdd7b656 / 99.0%\n0xdee9d3a767e08afcffc909e55d853a0069c2f46f / 1.00%"}
          />

          <ExpandableCard
            key={5}
            title={`DeSci - OpenDesign`}
            subtitle="製作一套細菌纖維素改質機器的線上模型，將模型零件以 NFT 方式線上開源共享，並在數位展間 Solana 中展示。供全球科學社群自行下載使用，製造出類似纖維素的新材料。"
            imageUrl="/images/RetroPGFSec4_6.jpeg"
            url=""
            expanded={expandedCards.includes(5)}
            onToggle={() => toggleExpansion(5)}
            expandtitle="Da0 DeSci - OpenDesign"
            expandsubtitle1="Description"
            expanddescription1={"The maker movement has spawned a variety of tools, particularly 3D printers, enabling people to easily bring their creative ideas to life. These technologies have not only blurred the lines between digital and physical design but also led to a new trend in open-source equipment. The current challenge lies in making designs more modular and shareable. In this regard, Web3 technology offers new possibilities, especially in innovating licensing mechanisms.\n\nThe OpenDesign project, initiated by DA0 DeSci, BioCreator, and Yi-Pin Huang from the Department of Multimedia Design at Shih Chien University, aims to create a community for 3D model design sharing, akin to open-source code sharing, while exploring new co-creation mechanisms with Web3 tools. Starting with the design of biological instruments, we will experiment using the SpinGrower bioreactor as a case study. OpenDesign is dedicated to establishing a community for the free exchange of design ideas, fostering innovation and collaboration, with the hope of demonstrating the spirit of the maker movement and further advancing personal manufacturing and design through shared and evolving designs.\n\n自造者運動催生了各類工具，特別是3D列印機，讓人們能夠輕鬆實現創意。這些技術不僅淡化了數位與實體設計的界限，也引領了開源儀器的新潮流。現在的挑戰在於如何使設計更加模組化和易於共享。在這方面，Web3技術提供了新的可能性，尤其是在授權機制的創新上。\n\nOpenDesign項目，由DA0 DeSci、BioCreator、實踐大學多媒體設計系黃宜品發起，旨在打造一個類似於開源代碼共享的3D模型設計社群，結合Web3工具探索新的共創機制。以生物儀器設計為出發點，我們將以SpinGrower生物培養器為例進行實驗。OpenDesign致力於建立一個自由交流設計想法的社群，推動創新與合作，並期望通過共享和演進設計來展現自造者運動的精神，進一步推進個人製造和設計的發展。"}
            expandsubtitle2="Contributors"
            expanddescription2={"0xbf1a1710248fe4912577a174d7a493ac211d007b\n0x40f86bbcafbd8f1586e43a861e6cb93f86362938\n0xdd86a4e9de8debb2d703eb7d4abf76f95b938f70"}
            expandsubtitle3="Owners / Share"
            expanddescription3={"0xdee9d3a767e08afcffc909e55d853a0069c2f46f / 30.0%\n0xdd86a4e9de8debb2d703eb7d4abf76f95b938f70 / 20.0%\n0xdd86a4e9de8debb2d703eb7d4abf76f95b938f70 / 15.0%\nUnclaimed / 35.0%"}
          />

          <ExpandableCard
            key={6}
            title={`DeSci - DARTA`}
            subtitle="建立一個醫療資訊交換平台，評估 AI 判讀的醫療資訊準確度，供醫療機構使用，以此提供民眾更精確的診斷或預測結果，也讓民眾能以提供醫療資訊的方式，交換更精準的醫療服務，同時也能更掌握自己的資料。"
            imageUrl="/images/RetroPGFSec4_7.jpeg"
            url=""
            expanded={expandedCards.includes(6)}
            onToggle={() => toggleExpansion(6)}
            expandtitle="Da0 DeSci - DARTA - v1"
            expandsubtitle1="Description"
            expanddescription1={"In the future, individuals will be able to easily use medical models created by scientists, such as cardiovascular risk prediction. They can access these predictive services by authorizing their data. This approach will create a more diverse mechanism to promote the development of medical AI!\n\n未來個人可以輕易使用科學家創建的醫療模型如心臟血管風險預測，而其可以藉由授權資料的方式來取得這樣的預測服務，如此可以創造一個更多元的機制來促進醫療AI的發展!\n\nMedical AI applications hold significant promise for enhancing healthcare accessibility and scalability. However, the current centralized healthcare system's lack of adequate IT infrastructure hinders its full potential. Web3 technology could offer solutions in terms of individual ownership, sustainable model usage, and permissionless deployment.\n\nDARTA, is one of the initial projects from da0 desci, where we want to tackle the above problem and explore the possibility of combining  Web3 tools and med AI to benefit individuals and researchers.\n\n醫療人工智慧應用在提高醫療服務的可及性和擴展性方面具有重大潛力。然而，當前醫療系統的IT基礎設施其實不利於模型擴展以及個人資料擁有權的保證，無法充分發揮其潛力。Web3技術可能提供了一種解決方案，包括個人所有權、模型使用的可持續性和無需許可的部署等。\n\nDARTA是da0 desci的發起項目之一，旨在解決上述問題，並探索將Web3工具與醫療人工智慧相結合，以惠及個人和研究人員。它致力於創建一個精確的、基於估值的生物診斷和臨床實驗室測試數據市場。作為一個基於區塊鏈的平台，它提供了一個可信賴和無需許可的環境。DARTA強調數據的準確估值和強大的交易機制，促進了數據提供者和請求者之間的高效數據轉移。這種系統支持有效AI模型的開發，增強了醫療人工智慧的實用性和影響力。"}
            expandsubtitle2="Contributors"
            expanddescription2={"0xc5330cd724805355139f2b66716b1b7b17510864\n0xb59b62f384674c4f1fea875bfd520025cd73dfec\n0xbf1a1710248fe4912577a174d7a493ac211d007b"}
            expandsubtitle3="Owners / Share"
            expanddescription3={"0xb59b62f384674c4f1fea875bfd520025cd73dfec / 35.0%\n0xc5330cd724805355139f2b66716b1b7b17510864 / 35.0%\n0xdee9d3a767e08afcffc909e55d853a0069c2f46f / 30.0%"}
          />
        
      </LowerSection>
    </Section4Wrapper>
  );
};

export default RetroPGFSec4;

